/* eslint-disable object-shorthand */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-void */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { SetStateAction, useCallback, useEffect, useMemo, useState } from 'react'
import {Layout, Layouts, Responsive, WidthProvider} from "react-grid-layout";
import "react-grid-layout/css/styles.css";

import { v4 as uuidv4 } from "uuid";
import { Edit, EditTwoTone, Widgets } from '@material-ui/icons';
import { Modal } from '@material-ui/core';
import { Map as ImmutableMap} from 'immutable';
import {GridItemHeader} from './Widget';
import darkStyles from './LiveDark.module.css';
import lightStyles from './LiveLight.module.css';
import { breakpoints, columns, Widget, updateWidget, getWidgets, deltaGetter, callStateGetter, Dashboard, getDashboards, deleteGridItem } from './Utilities';
import AddNewWidgetItem from './AddNewWidgetItem';
import testDashboards from './testDashboards.json'
import testData from './testData.json'


import { QueueCallState } from '../QueueLeaderboard';
import { MetricObject } from '../QueueWidgetContainer';
import { WidgetRegistry } from './WidgetRegistry';

const ResponsiveGridLayout = WidthProvider(Responsive)

const DashboardTabs = ({
  dashboards,
  setWidgets,
  setDashboards,
  selectedDashboard,
  setSelectedDashboard,
  setLiveDashboardErrorMsg,
  styles,

}: {
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>;
  dashboards: Map<String, Dashboard>;
  setDashboards: React.Dispatch<React.SetStateAction<Map<string, Dashboard>>>;
  selectedDashboard: Dashboard | undefined;
  setLiveDashboardErrorMsg:React.Dispatch<SetStateAction<string | undefined>>;
  setSelectedDashboard: React.Dispatch<React.SetStateAction<Dashboard | undefined>>;
  styles: any;
}) => {
 
  return (
    <div className={styles.headerGroup}>
      {Array.from(dashboards.entries()).map(([key, dashboard]) => (
        <button
          data-dashboard-selected={selectedDashboard?.dashboardId === key}
          onClick={() => setSelectedDashboard(dashboards.get(key))}
          type="button"
          className={selectedDashboard?.dashboardId === key ? styles.gridToolbarButtonSelected : styles.gridToolbarButton}
        >
          <span>{dashboard.name}</span>
        </button>
      ))}
    </div>
  );
};
 const LiveResponsiveGrid = React.memo(({ accessToken, tabCounts, orgId, liveQueueMetrics, queueCallStates, lightMode, userDeltas, queueDeltas, historicalUserList, historicalQueueList}: {tabCounts: {
    voicemail: number;
    callback: number;
    abandoned: number;
}, orgId: string | undefined, accessToken: string; liveQueueMetrics: Map<String, MetricObject>; queueCallStates: QueueCallState[], lightMode: boolean, userDeltas: any; queueDeltas: any, historicalUserList: any; historicalQueueList: any}) => {
        const [layouts, setLayouts] = useState<Layouts>({});
        const [widgets, setWidgets] = useState<Map<string, Widget>>(new Map())
        const [dashboards, setDashboards] = useState<Map<string, Dashboard>>(new Map())
        const [selectedDashboard, setSelectedDashboard] = useState<Dashboard | undefined>(undefined)
        const [newWidget, setNewWidget] = useState<Partial<Widget> | undefined>()
        const [quickEditMode, setQuickEditMode] = useState(false)
        const [currentBreakpoint, setCurrentBreakpoint] = useState("lg")
        const [liveDashboardErrMsg, setLiveDashboardErrorMsg] = useState<string | undefined>()
        const styles = lightMode ? lightStyles : darkStyles;


        // console.log('QUEUE DELTAS: ', queueDeltas)
        // console.log('USER DELTAS: ', userDeltas)
        // console.log('LIVE QUEUE DELTA METRICS: ', liveQueueMetrics)
        // console.log("LIVE QUEUE MONITOR: ", queueCallStates)

        useEffect(() => {
          setLayouts(() => {
            const newlayout: Layouts = {
              xxs: [],
              xs: [],
              sm: [],
              md: [],
              lg: []
            }
            Array.from(widgets.values())
            // .filter((widget) => widget.dashboardId === selectedDashboard?.dashboardId)
            .forEach((_widget) => {
              newlayout.xxs.push(_widget.layout!.xxs!);
              newlayout.xs.push(_widget.layout!.xs!);
              newlayout.sm.push(_widget.layout!.sm!);
              newlayout.md.push(_widget.layout!.md!);
              newlayout.lg.push(_widget.layout!.lg!);

            })
            return newlayout;
          })
        }, [widgets, selectedDashboard])


        // GET the historical dashboard list (JSON FILE)
        useEffect(() => {
          if (orgId) {
            const dashboardMap = new Map();
            testDashboards.forEach((dashboard) => {
              dashboardMap.set(dashboard.dashboardId, dashboard)
            })
            setDashboards(dashboardMap);
          }
        }, [orgId])

        // GET the historical dashboard list (from server)
        // useEffect(() => {
        //   if (orgId) {
        //     getDashboards(setDashboards, setLiveDashboardErrorMsg, orgId)
        //   }
        // } ,[orgId])

        // once dashboards are fetched, assign the selected dashboard
        useEffect(() => {
          if (dashboards && dashboards.size > 0) {
            console.log('dashboards: ', dashboards)
            setSelectedDashboard(Array.from(dashboards.values())?.[0])
          }
        }, [dashboards])

        // once dashboards and selected dashboards loaded, set the widgets (SERVER)
        // useEffect(() => {
        //   if (dashboards && selectedDashboard) {
        //     localStorage.setItem(`live-grid-dashboard-tab`, JSON.stringify(selectedDashboard))
        //     getWidgets(setWidgets, setLiveDashboardErrorMsg, selectedDashboard)
        //     }
        // }, [selectedDashboard]);

        // once dashboards and selected dashboards loaded, set the widgets from (JSON FILE)
        useEffect(() => {
            const widgetMap = new Map<string, Widget>();
            (testData as Widget[]).forEach((item: Widget) => {
              if (item.dashboardId === selectedDashboard?.dashboardId) {
                widgetMap.set(item.widgetId!, item);
              }
            });
            setWidgets(widgetMap); 
        }, [selectedDashboard])

        const handleBreakpointChange = useCallback((breakpoint) => {
          return setCurrentBreakpoint(breakpoint)
        }, [currentBreakpoint])



        const handleLayoutChange = (_currentLayout: Layout[], allLayouts: Layouts) => {
          if (!widgets || !widgets.size) return;

          // new widgets instance
          const updatedWidgets = new Map(widgets);

          const breakpointArray: Array<'xxs' | 'xs' | 'sm' | 'md' | 'lg'> = ["xxs", "xs", "sm", "md", "lg"];

          breakpointArray.forEach((breakpoint) => {
            const currentBreakpointLayout = allLayouts[breakpoint];
            currentBreakpointLayout.forEach(({i, ...layoutProps}) => {
              const widget = updatedWidgets.get(i);
              if (widget?.layout) {
                widget.layout[breakpoint] = {i, ...layoutProps}
              }
            })
          })

          updateWidget(updatedWidgets, setLiveDashboardErrorMsg);
          setWidgets(updatedWidgets)
        };


        const editWidget = useCallback((widgetId: string) => {
          if (!widgetId) return;
          setNewWidget(widgets.get(widgetId))
        }, [newWidget, widgets])






        const getWidgetContent = useCallback((itemId) => {
          return widgets.get(itemId)
        }, [widgets])
           
        const getMemoizedCallStates = useCallback((itemId) => {
          const widget = widgets.get(itemId);
          return callStateGetter(widget, userDeltas, queueDeltas);
        }, [widgets, userDeltas, queueDeltas]);


        const getMemoizedDeltas = useCallback((itemId) => {
            const widget = widgets.get(itemId);
            return deltaGetter(widget, userDeltas, queueDeltas);
        }, [widgets, userDeltas, queueDeltas])

    return (
       <>
       <AddNewWidgetItem 
        newWidget={newWidget} 
        accessToken={accessToken}
        historicalUserList={historicalUserList}
        userDeltas={userDeltas}
        queueDeltas={queueDeltas}
        currentBreakpoint={currentBreakpoint}
        historicalQueueList={historicalQueueList}
        setWidgets={setWidgets}
        lightMode={lightMode}
        setLiveDashboardErrorMsg={setLiveDashboardErrorMsg}
        setNewWidget={setNewWidget}
        styles={styles}
        liveQueueMetrics={liveQueueMetrics}
       />
        <div className={styles.gridHeader}>
          {/* {
          liveDashboardErrMsg && (
              <div className={styles.errorMessage}>
                <span>{liveDashboardErrMsg}</span>
                <div style={{display: 'flex'}}>
                  <button type="button" onClick={() => setLiveDashboardErrorMsg(undefined)}>OK</button>
                <button type="button" onClick={() => {
                  setLiveDashboardErrorMsg(undefined);
                  getWidgets(setWidgets, setLiveDashboardErrorMsg, selectedDashboard)
                  }}>Refresh</button>
                  </div>
              </div>
            )
          } */}
          <div className={styles.headerGroup}>
            {
              dashboards && dashboards.size > 0 && (
                <DashboardTabs 
                setWidgets={setWidgets}  
                dashboards={dashboards} 
                setDashboards={setDashboards} 
                setSelectedDashboard={setSelectedDashboard} 
                setLiveDashboardErrorMsg={setLiveDashboardErrorMsg}
                selectedDashboard={selectedDashboard} 
                styles={styles} 
                />
              )
            }
           {" "}
          </div>
           <div className={styles.headerGroup}>
            <button className={styles.gridToolbarButton} type="button" onClick={() => setNewWidget({
              dashboardId: selectedDashboard?.dashboardId
            })}> 
            <span className={styles.toolbarText}><Widgets /> Add new Widget </span></button>
            <button className={styles.gridToolbarButton} type="button" onClick={() => setQuickEditMode((p) => !p)}>{quickEditMode ? <span className={styles.toolbarText}><Edit /> Quick Edit ON</span> : <span className={styles.toolbarText}><EditTwoTone />Quick Edit OFF</span>}</button>
          </div>
        </div>
        <ResponsiveGridLayout
          cols={columns}
          layouts={layouts}
          rowHeight={30}
          breakpoints={breakpoints}
          // compactType={null}
          onBreakpointChange={handleBreakpointChange}
          onLayoutChange={handleLayoutChange}
          compactType="vertical"
          measureBeforeMount={false}
          isResizable={quickEditMode}
          isDraggable={quickEditMode}
          draggableHandle='#grid-item-handle'
          resizeHandles={quickEditMode ? [
            // "s", "w", "e", 
            "se", "sw"] : undefined}
          useCSSTransforms={false}
          preventCollision={false}
        >
          {layouts && layouts[currentBreakpoint] && layouts[currentBreakpoint].map((item) => (
              <div key={item.i} className={styles.gridItemContainer}
              style={{
                background: widgets.get(item.i)?.cosmetics?.bgColor ? 
                `linear-gradient(337deg, ${widgets.get(item.i)?.cosmetics?.bgColor}${lightMode ? "ee" : "aa"}, ${widgets.get(item.i)?.cosmetics?.bgColor}${lightMode ? "7d" : "aa"})`
                 : ""
              }}>
                 <GridItemHeader
                    accessToken={accessToken} widgetContent={widgets.get(item.i)}
                    styles={styles} quickEditMode={!!quickEditMode}
                    layout={item} editWidget={editWidget} setWidgets={setWidgets}
                    widgets={widgets} setLiveDashboardErrorMsg={setLiveDashboardErrorMsg}
                  />
                  {WidgetRegistry.renderWidget(widgets.get(item.i)?.key || "", {
                    styles: styles,
                    layout: item,
                    historicalUsers: historicalUserList,
                    historicalQueues: historicalQueueList,
                    accessToken: accessToken,
                    lightMode: lightMode,
                    widgetContent: {...widgets.get(item.i)},
                    liveQueueMetrics: liveQueueMetrics,
                    queueDeltas: queueDeltas,
                    userDeltas: userDeltas,
                    widgetId: widgets.get(item.i)?.widgetId,

                    // will need to remove this
                    queueCallStates: getMemoizedCallStates(item.i),
                    // will need to remove this
                    deltas: getMemoizedDeltas(item.i),


                  })}
              </div>
            ))
          }
        </ResponsiveGridLayout>
       </>
        )
})


export default LiveResponsiveGrid;